package com.milta.core.localization.translations.de

import com.milta.core.localization.OptimizationQuotaStrings

internal val OptimizationQuota = OptimizationQuotaStrings(
    exhaustedTitle = "Optimierungskontingent erreicht",
    exhaustedCreateRouteMessage = "Wieder verfügbar am {date}. Sie können die Tour ohne Optimierung erstellen: Die eingegebene Reihenfolge bleibt erhalten.",
    exhaustedCreateBatchMessage = "Wieder {limit} Optimierungen am {date}. Der Stapel kann ohne Optimierung erstellt werden: Die eingegebene Reihenfolge bleibt erhalten.",
    quotaReachedResetOn = "Optimierungskontingent erreicht — Zurücksetzung am {date}",
    routeCreatedInEnteredOrder = "Tour in der eingegebenen Reihenfolge erstellt.",
    routeWillBeCreatedInEnteredOrder = "Die Tour wird in der eingegebenen Reihenfolge erstellt.",
    batchCreatedInEnteredOrder = "Der Stapel wurde ohne Optimierung in der eingegebenen Reihenfolge erstellt.",
    sendWithoutOptimization = "Ohne Optimierung senden",
    batchNotOptimizedTitle = "Stapel ohne Optimierung erstellt",
    batchNotOptimizedMessage = "Optimierungskontingent erreicht. Die aktuelle Reihenfolge der Stopps bleibt erhalten.",
    batchNotOptimizedMobileMessage = "Stapel ohne Optimierung erstellt: Optimierungskontingent erreicht. Eingegebene Reihenfolge beibehalten, Stopps gleichmäßig verteilt.",
    reoptimizeAction = "Neu optimieren",
    reoptimizeUnavailableWeb = "Neu-Optimierung nicht verfügbar: Kontingent erreicht, wieder am {date}. Die aktuelle Reihenfolge bleibt erhalten und das Senden ist weiterhin möglich.",
    reoptimizeUnavailableMobile = "Neu-Optimierung bis {date} nicht verfügbar (Kontingent erreicht). Das Senden ist weiterhin möglich.",
    stopAddedAtEndTitle = "Stopp am Ende der Tour hinzugefügt",
    stopAddedAtEndMessage = "Optimierungskontingent erreicht — Zurücksetzung am {date}. Die Reihenfolge der anderen Stopps ändert sich nicht.",
    reoptimizeExhaustedHint = "Optimierungskontingent erreicht, wieder am {date}",
    myOptimizationsTitle = "Meine Optimierungen",
    remainingForPeriod = "Verbleibend in diesem Zeitraum",
    remainingSuffix = "verbleibend",
    resetLabel = "Zurücksetzung",
    resetAtRenewal = "Bei Verlängerung des Abonnements",
    driverExplanation = "Wird bei der Verlängerung Ihres Abonnements zurückgesetzt. Fahrer eines Unternehmens: Ihr Zähler folgt dem Abonnement des Unternehmens, mit dem Testlimit, solange es in der Testphase ist.",
    enterpriseExplanation = "Wird bei der Verlängerung Ihres Abonnements zurückgesetzt. Dieser Zähler betrifft nur Ihre eigenen Optimierungen; jeder Fahrer hat seinen eigenen.",
    webCounterNotice = "Dieser Zähler betrifft nur die von diesem Konto gestarteten Optimierungen. Jeder Fahrer hat seinen eigenen, sichtbar in seiner App.",
    historyTitle = "Verlauf",
    columnDate = "Datum",
    columnAction = "Aktion",
    columnTarget = "Betroffene Tour",
    columnOutcome = "Ergebnis",
    actionOptimizeRoute = "Eine Tour optimieren",
    actionCreateRouteBatch = "Einen Stapel erstellen",
    actionReoptimizeRouteBatch = "Einen Stapel neu optimieren",
    actionReoptimizeOnStopAdded = "Beim Hinzufügen eines Stopps neu optimieren",
    actionReoptimizeInPlace = "Unterwegs neu optimieren",
    actionCreateOwnRoute = "Meine Tour erstellen",
    outcomeCounted = "Gezählt",
    outcomeRefunded = "Zurückgegeben",
    outcomeRefundedLong = "Zurückgegeben — RoutaR-Fehler",
    refundedNotCounted = "RoutaR-Fehler, nicht gezählt",
    targetRoute = "Tour vom {date}",
    targetBatch = "Stapel vom {date}",
    historyLoadingMore = "Nächste Zeilen werden geladen…",
    historyEnd = "Ende des Verlaufs — {count} Zeilen",
    historyEmpty = "Keine Optimierung in diesem Zeitraum.",
    historyLoadError = "Der Verlauf konnte nicht geladen werden.",
    retryAction = "Erneut versuchen",
    loading = "Wird geladen…",
    errorNoConnection = "Server nicht erreichbar — prüfen Sie Ihre Verbindung.",
    errorGeneric = "Ein Fehler ist aufgetreten. Bitte später erneut versuchen.",
    tabOptimizations = "RoutaR-Optimierungen",
    tabAiTokens = "KI-Tokens",
    comingSoon = "Demnächst",
    limitsDescription = "Anzahl der erlaubten RoutaR-Optimierungen pro Konto und Abonnementzeitraum, je nach Kontotyp und Abonnementstatus. Der Zähler jedes Kontos wird bei der Verlängerung seines Abonnements zurückgesetzt.",
    columnTrial = "Test",
    columnPaid = "Bezahlt",
    rowEnterprise = "Unternehmenskonto",
    rowDriver = "Fahrer",
    fieldRequired = "Pflichtfeld.",
    fieldMustBePositive = "Muss größer als 0 sein.",
    limitsFootnote = "Werte in Optimierungen pro Zeitraum. Ein Fahrer eines Unternehmens erhält das Limit „Fahrer“, Test solange sein Unternehmen in der Testphase ist, sonst bezahlt.",
    limitsSaved = "Limits gespeichert. Unternehmen: {enterpriseTrial} Test · {enterprisePaid} bezahlt. Fahrer: {driverTrial} Test · {driverPaid} bezahlt.",
    limitsRejected = "Werte abgelehnt: Jedes Limit muss größer als 0 sein.",
    saveAction = "Speichern",
    detailsAction = "Details",
    accountDetailsTitle = "Benutzerdetails",
    sectionIdentity = "Identität",
    accountTypeLabel = "Kontotyp",
    kindEnterpriseOwner = "Unternehmenskonto",
    kindEnterpriseDriver = "Fahrer eines Unternehmens",
    kindIndependentDriver = "Selbstständiger Fahrer",
    withoutOrganisation = "Ohne Organisation",
    subscriptionLabel = "Abonnement",
    viaOrganisation = "Über Organisation",
    subscriptionTrial = "Test",
    subscriptionPaid = "Bezahlt",
    appliedLimitLabel = "Angewandtes Limit",
    limitKindEnterprise = "Limit Unternehmenskonto",
    limitKindDriver = "Limit Fahrer",
    enterpriseInTrialSuffix = "(das Unternehmen ist in der Testphase)",
    resetSourceOwn = "Verlängerung des Abonnements",
    resetSourceEnterprise = "Verlängerung von {enterprise}",
    exhaustedBadge = "Kontingent aufgebraucht",
    manuallyAdjustedBadge = "Manuell ersetzt",
    replaceLabel = "Verbleibende Anzahl ersetzen",
    replaceAction = "Ersetzen",
    replaceHelp = "Nur für den aktuellen Zeitraum. Bei der Zurücksetzung startet das Konto wieder mit dem globalen Limit.",
    replaceHelpEnterpriseDriver = "Ändert nur den Zähler von {name}. Der des Unternehmens und der anderen Fahrer ändert sich nicht.",
    replaceInvalid = "Geben Sie eine Zahl größer oder gleich 0 ein.",
    replaceRejected = "Wert vom Server abgelehnt.",
    replaceMaximum = "Maximal 100.000.",
    replacedBanner = "Verbleibende Anzahl ersetzt: {from} → {to}. Für den aktuellen Zeitraum. Am {date} zurück zum globalen Limit ({limit}).",
    adminHistoryTitle = "Verlauf der Optimierungen",
    accountNotFound = "Konto nicht gefunden.",
)
